angular.module("vgresiduos").controller("DestinationTemporaryStorageArrivalCtrl", [
	"$scope",
	function ($scope) {
		"use strict";

		$scope.isResidueStep = function () {
			return $scope.destinationConfig.currentStepPointer == $scope.stepsEnum.A;
		};

		$scope.isManifesStep = function () {
			return $scope.destinationConfig.currentStepPointer == $scope.stepsEnum.B;
		};

		$scope.enableStep = function (stepId) {
			if ($scope.isCurrentStageReview()) {
				return;
			}

			if (!isStepEnabled(stepId)) {
				$scope.destinationConfig.enabledStepPointer = stepId;
			}
		};

		$scope.enableBackToStep = function (stepId) {
			if ($scope.isCurrentStageReview()) {
				return;
			}

			$scope.destinationConfig.enabledStepPointer = stepId;
		};

		function isStepEnabled(stepId) {
			return stepId <= $scope.destinationConfig.enabledStepPointer;
		}
	}
]);
